import { KdsCombobox } from "@kazaar-platform/design-system";
import { Controller, useFormContext } from "react-hook-form";
import { type ControlledComboboxProps } from "./ControlledCombobox.types";

const ControlledCombobox = ({
  name,
  options,
  resetKey,
  ...inputProps
}: ControlledComboboxProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <KdsCombobox
          {...inputProps}
          options={options}
          key={resetKey}
          name={field.name}
          onBlur={field.onBlur}
          selectedKey={field.value ?? null}
          onSelectionChange={(key) => {
            field.onChange(key);
            inputProps.onSelectionChange?.(key);
          }}
          onCreateOption={(value) => {
            field.onChange(value);
            inputProps.onCreateOption?.(value);
          }}
          hasError={!!error}
          errorMessage={error?.message?.toString()}
        />
      )}
    />
  );
};

export { ControlledCombobox };
